import {
  FilterMode,
  TenantCreateMutationVariables,
  Tenant_OrderBy,
  Tenant,
  SortOrder,
  Tenant_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantService = {
  createOne: buildCreateOne(
    (tenantCreateVariables: TenantCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantCreate(tenantCreateVariables);
        return result.tenantCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantOne({ id });
    return result.tenantOne as Tenant;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Tenant_OrderBy[] | null = null,
    filter: Tenant_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Tenant_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantListWithOffset
    ) as Tenant[];
    return { list, orderBy };
  },
};
